'use client'
import { useEffect, useState } from 'react'

export default function OfflineWrapper({
  children,
}: {
  children: React.ReactNode
}) {
  const [isOnline, setIsOnline] = useState(true)

  useEffect(() => {
    const update = () => setIsOnline(navigator.onLine)
    window.addEventListener('online', update)
    window.addEventListener('offline', update)
    update()
    return () => {
      window.removeEventListener('online', update)
      window.removeEventListener('offline', update)
    }
  }, [])

  useEffect(() => {
    if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/sw.js')
        .then(() => console.log('✅ Service Worker registered'))
        .catch((err) => console.error('SW registration failed:', err))
    }
  }, [])

  if (!isOnline) {
    return (
      <div
        style={{
          fontFamily: 'Arial, sans-serif',
          textAlign: 'center',
          background: 'white',
          minHeight: '98vh',
          margin: '0px',
          padding: '0px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div style={{ maxWidth: '400px', margin: '0 auto' }}>
          <p
            style={{
              marginBottom: '1rem',
              fontSize: '25px',
              fontWeight: 'bold',
            }}
          >
            Ошибка сети 🚫
          </p>
          <p style={{ marginBottom: '1.5rem', lineHeight: '28px' }}>
            Не удалось загрузить меню. Проверьте интернет и попробуйте ещё раз.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: '#454ce7',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '12px',
              fontSize: '1rem',
              cursor: 'pointer',
              border: 'none',
            }}
          >
            Обновить
          </button>
        </div>
      </div>
    )
  }

  return <>{children}</>
}
